import React from 'react'
import * as S from './Fieldset.styles'

const Fieldset = ({ children }) => <S.Fieldset>{children}</S.Fieldset>

export { Fieldset }
